import { Skeleton } from 'antd';
import React from 'react';
import { NotificationStatus } from 'api/notifications';
import { Content as ContentT } from 'stores/notifications';
import { unreachable } from 'utils/unreachable';
import { Content } from './content';

export const renderContent = (
  status: NotificationStatus,
  content: ContentT,
) => {
  switch (content[0]) {
    case 'empty':
      return null;
    case 'fetching_first_page':
      return <Skeleton active />;
    case 'fetching':
    case 'fetched':
    case 'fetched_last_page':
      return <Content status={status} content={content} />;
    default:
      return unreachable(content);
  }
};
